import React, { useEffect } from 'react';
import { useCompetitionProps } from '../../hooks/content/useCompetitionProps';
import { useCustomerApi } from '../../../customers/hooks/customerApi';
import { CustomerApiRecord } from '../../../customers/api/customer/types';
import { styles } from './FormatForm.css';

export type FormatFormProps = {
  formString: string;
};

const prefillForm = (formString: string, customer: CustomerApiRecord | Record<string, any>): string => {
  if (!customer) {
    return formString;
  }

  const fieldMapping = {
    tfa_1: customer.firstName,
    tfa_19: customer.lastName ?? '',
    tfa_3: customer.email,
    tfa_5: customer.primaryPhone ?? '',
  };

  return formString.replace(/<input type="hidden" id="([^"]+)" name="[^"]+" value="" class="">/g, (match, id) => {
    const newValue = fieldMapping[id as keyof typeof fieldMapping];
    return match.replace('value=""', `value="${newValue}"`);
  });
};

const removeTagsFromString = (value: string): string =>
  value.replaceAll(/<style((.|\n|\r)*?)<\/style>|<script((.|\n|\r)*?)<\/script>/g, '');

export const FormatForm = ({ formString }: FormatFormProps) => {
  const { data } = useCompetitionProps();
  const { customer } = useCustomerApi();

  const shouldPrefill = data?.isCompetitionPerksOnly && data?.isUserPerks;
  const prefilledFormString = shouldPrefill ? prefillForm(formString, customer) : formString;
  const cleanFormString = removeTagsFromString(prefilledFormString);

  useEffect(() => {
    // need to re-initialise Form Assembly to pick up the form in react. Form Assembly JS is loaded in theme.liquid
    // <head> if the template is a competition template
    if (window?.wFORMS) {
      window.wFORMS.onLoadHandler();
    }
  }, [customer]);

  if (data?.isCompetitionPerksOnly && (data?.enteredOn || !data?.isUserPerks || !customer?.id)) {
    return null;
  }

  return <div className={styles.form} dangerouslySetInnerHTML={{ __html: cleanFormString }} />;
};
